import React, { Component } from "react"

import { Form, FormGroup, Label, Input, Col, Modal, Row } from "reactstrap"
import mainFunctions from "../../../components/Functions"

class MultiPayment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      payment_methods: mainFunctions.getPaymentMethods(),
      rows: []
    }
  }
  componentDidMount() {
    let rows = []
    this.state.payment_methods.forEach(payment_method => rows.push({id: payment_method.value, amount: 0, discount: 0}));

    this.setState({ rows: rows });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {

  }
  updateAmount = (amount, id) => {
    const { rows } = this.state;

    let row = rows.find(x => x.id === id)
    row.amount = amount;

    this.setState({ rows: rows });
  }
  updateDiscount = (discount, id) => {
    const { rows } = this.state;

    let row = rows.find(x => x.id === id)
    row.discount = discount;

    this.setState({ rows: rows });
  }
  create = () => {
    const {rows} = this.state;

    this.props.completeTransactionMultiPaymentMethod(rows.filter(function(row){ return row.amount > 0 }));
  }
  render() {
    const {payment_methods, rows} = this.state;
    const {modal_create, topOption, discount, total} = this.props;

    if(rows.length === 0) return '';
    return (
      <React.Fragment>
        <Modal
          isOpen={modal_create}
          toggle={() => topOption()}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myModalLabel">
              Multi Pagos
            </h5>
            <button
              type="button"
              onClick={() => topOption()}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="table-responsive" style={{overflowY: 'hidden'}}>
              <table className="table align-middle table-nowrap mb-0">
                <tbody>
                <tr>
                  <td style={{width: '30%'}}>
                    SubTotal
                  </td>
                  <td style={{width: '35%'}}>
                    <Input
                      type="text"
                      className="inner form-control"
                      placeholder={'Valor...'}
                      value={total}
                      disabled={true}
                    />
                  </td>
                  <td/>
                </tr>
                <tr>
                  <td style={{width: '35%'}}>
                    Descuento
                  </td>
                  <td style={{width: '35%'}}>
                    <Input
                      type="text"
                      className="inner form-control"
                      placeholder={'Valor...'}
                      value={discount * -1}
                      disabled={true}
                    />
                  </td>
                  <td/>
                </tr>
                <tr>
                  <td style={{width: '30%'}}>
                    Total
                  </td>
                  <td style={{width: '35%'}}>
                    <Input
                      type="text"
                      className="inner form-control"
                      placeholder={'Valor...'}
                      value={total - discount}
                      disabled={true}
                    />
                  </td>
                  <td/>
                </tr>
                {
                  payment_methods.map((payment_method, index) => {
                      return(
                        <tr key={`input_payment_method_${payment_method.value}`}>
                          <td style={{width: '30%'}}>
                            {payment_method.label}
                          </td>
                          <td style={{width: '35%'}}>
                            <Input
                              type="number"
                              className="inner form-control"
                              placeholder={'Valor...'}
                              value={rows.find(x => x.id === payment_method.value).amount}
                              onChange={ e => {this.updateAmount(e.target.value, payment_method.value)} }
                            />
                          </td>
                          <td style={{width: '35%'}}>
                            <Input
                              type="number"
                              className="inner form-control"
                              placeholder={'Valor...'}
                              value={rows.find(x => x.id === payment_method.value).discount}
                              onChange={ e => {this.updateDiscount(e.target.value, payment_method.value)} }
                            />
                          </td>
                        </tr>
                      )
                    }
                  )
                }
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => topOption()}
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.create}
            >
              Crear
            </button>
          </div>
        </Modal>
      </React.Fragment>
    )
  }
}
export default MultiPayment;